
import {
    Box
} from '@chakra-ui/react';
import { useSelector } from "react-redux";


import WaitingTimePerService from "../../components/organization/reports/WaitingTimePerService";
import _ from 'lodash';
import { getReportDescription } from '../../store/helpers';
import * as defaultSelectors from "../../store/selectors/defaultSelector";
import {
  WAITING_TIME_PER_SERVICE_COLUMN_DEFINITIONS,
  getRenderConfigSummaryItems,
} from "../../store/renderConfig";

const WaitingTimePerServicePage = ({

  reportIndex = "**REPORT_INDEX**",
}) => {
  const reportRange = useSelector(defaultSelectors.selectReportRange);
  const reportsData = useSelector(defaultSelectors.selectReportsData);
  const renderConfig = useSelector(defaultSelectors.selectRenderConfig);
  const { data } = reportsData;

  const reportTitle = `${reportIndex}. Waiting Time Per Service`;
  const presentationSummaryItems = getRenderConfigSummaryItems(renderConfig, {
    columnDefinitions: WAITING_TIME_PER_SERVICE_COLUMN_DEFINITIONS,
  });

  return (
    <Box>
      <Box mb="20px">
        <h1>{reportTitle}</h1>
        <p>{getReportDescription(reportRange).WaitingTimePerService}</p>
        {presentationSummaryItems.length ? (
          <div className="reportPresentationSummary">
            <strong>PRESENTATION</strong> {presentationSummaryItems.join(" / ")}
          </div>
        ) : null}
      </Box>
      {!_.isEmpty(data) ? (
        <WaitingTimePerService reportIndex={reportIndex} data={data} />
      ) : <Box mt={10}>
              <p>No data available in this report</p>
            </Box>}
    </Box>
  );
};

export default WaitingTimePerServicePage;
